//header fixed
$(".wd-product-page-header-handle").click(function () {
    if ($(this).hasClass("wd-product-page-header-handle-active")) {
        $(this).removeClass("wd-product-page-header-handle-active");
        $(this).addClass("wd-product-page-header-handle-active2");
        $(this).siblings(".wd-product-page-header-handle-menu").slideUp();
    } else {
        $(this).removeClass("wd-product-page-header-handle-active2");
        $(this).addClass("wd-product-page-header-handle-active");
        $(this).siblings(".wd-product-page-header-handle-menu").slideDown();
    }
});
$(document).scroll(function () {
    var scroH = $(document).scrollTop();
    var header = $(".wd-product-page-content").offset().top;
    if (scroH >= header) {
        $(".wd-product-page-header").css("position", "fixed");
        $(".wd-product-page-header").css("z-index", "3");
    } else {
        $(".wd-product-page-header").css("position", "absolute");
        $(".wd-product-page-header").css("z-index", "2");
    }
});

//banner video show
$(".wd-product-page-banner-video").click(function () {
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-banner-video-show iframe")
        .prop("src", "https://www.youtube.com/embed/dGlfk1kYvos");
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-banner-video-show")
        .fadeIn(200);
    $(this).parents("html").css("overflow", "hidden");
});

$(".wd-product-page-videos-item")
    .eq(0)
    .click(function () {
        $(this)
            .parents(".wd-product-page-content")
            .find(".wd-product-page-banner-video-show iframe")
            .prop("src", "https://www.youtube.com/embed/QJahCaKNAUs");
        $(this)
            .parents(".wd-product-page-content")
            .find(".wd-product-page-banner-video-show")
            .fadeIn(200);
        $(this).parents("html").css("overflow", "hidden");
    });

$(".wd-product-page-videos-item")
    .eq(1)
    .click(function () {
        $(this)
            .parents(".wd-product-page-content")
            .find(".wd-product-page-banner-video-show iframe")
            .prop("src", "https://www.youtube.com/embed/dGlfk1kYvos");
        $(this)
            .parents(".wd-product-page-content")
            .find(".wd-product-page-banner-video-show")
            .fadeIn(200);
        $(this).parents("html").css("overflow", "hidden");
    });
$(".wd-product-page-videos-item")
    .eq(2)
    .click(function () {
        $(this)
            .parents(".wd-product-page-content")
            .find(".wd-product-page-banner-video-show iframe")
            .prop("src", "https://www.youtube.com/embed/qMq45_bwSU8");
        $(this)
            .parents(".wd-product-page-content")
            .find(".wd-product-page-banner-video-show")
            .fadeIn(200);
        $(this).parents("html").css("overflow", "hidden");
    });
$(".wd-product-page-videos-item")
    .eq(3)
    .click(function () {
        $(this)
            .parents(".wd-product-page-content")
            .find(".wd-product-page-banner-video-show iframe")
            .prop("src", "https://www.youtube.com/embed/TruGKoHmDzs");
        $(this)
            .parents(".wd-product-page-content")
            .find(".wd-product-page-banner-video-show")
            .fadeIn(200);
        $(this).parents("html").css("overflow", "hidden");
    });

$(".wd-product-page-banner-video-show-btn").click(function () {
    $(this).parents(".wd-product-page-banner-video-show").fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-banner-video-show iframe")
        .prop("src", "");
    $(this).parents("html").css("overflow", "auto");
});
$(".wd-product-page-banner-video-show").click(function () {
    $(this).fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-banner-video-show iframe")
        .prop("src", "");
    $(this).parents("html").css("overflow", "auto");
});
$('.wd-product-page-videos-item-share a').click(function (event) {
    event.stopPropagation();
});

//click choose card
$(".wd-product-page-header-title").click(function () {
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-header-handle-menu")
        .slideUp(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-faq")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-compares")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-videos")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-overview")
        .fadeIn();

    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle")
        .removeClass("wd-product-page-header-handle-active");
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle")
        .addClass("wd-product-page-header-handle-active2");
    $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-compares").click(function () {
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-compares")
        .fadeIn(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-overview")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-faq")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-videos")
        .fadeOut(200);
    $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-compares").click(function () {
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-compares")
        .fadeIn(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-overview")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-faq")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-videos")
        .fadeOut(200);

    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle-menu")
        .slideUp();
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle")
        .removeClass("wd-product-page-header-handle-active");
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle")
        .addClass("wd-product-page-header-handle-active2");
    $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-faq").click(function () {
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-faq")
        .fadeIn(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-overview")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-videos")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-compares")
        .fadeOut(200);

    $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-faq").click(function () {
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-faq")
        .fadeIn(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-overview")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-compares")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .siblings(".wd-product-page-videos")
        .fadeOut(200);

    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle-menu")
        .slideUp();
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle")
        .removeClass("wd-product-page-header-handle-active");
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle")
        .addClass("wd-product-page-header-handle-active2");
    $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-videos").click(function () {
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-videos")
        .fadeIn(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-overview")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-faq")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-compares")
        .fadeOut(200);

    $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-videos").click(function () {
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-videos")
        .fadeIn(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-overview")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-compares")
        .fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-faq")
        .fadeOut(200);

    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle-menu")
        .slideUp();
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle")
        .removeClass("wd-product-page-header-handle-active");
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-header-handle")
        .addClass("wd-product-page-header-handle-active2");
    $("html").animate({ scrollTop: 0 }, 0);
});

//faq click show
$(".wd-product-page-faq-content-q").click(function () {
    if (
        $(this)
            .parents(".wd-product-page-faq-content")
            .find(".wd-product-page-faq-content-a")
            .css("display") == "none"
    ) {
        $(this)
            .parents(".wd-product-page-faq-content")
            .siblings(".wd-product-page-faq-content")
            .find(".wd-product-page-faq-content-a")
            .slideUp();
        $(this)
            .parents(".wd-product-page-faq-content")
            .siblings(".wd-product-page-faq-content")
            .find(".wd-product-page-faq-content-q-minus")
            .css("display", "none");
        $(this)
            .parents(".wd-product-page-faq-content")
            .siblings(".wd-product-page-faq-content")
            .find(".wd-product-page-faq-content-q-add")
            .css("display", "block");

        $(this)
            .parents(".wd-product-page-faq-content")
            .find(".wd-product-page-faq-content-a")
            .slideDown();
        $(this)
            .parents(".wd-product-page-faq-content")
            .find(".wd-product-page-faq-content-a")
            .css("display", "flex");
        $(this)
            .find(".wd-product-page-faq-content-q-svg svg")
            .css("display", "none");
        $(this)
            .find(".wd-product-page-faq-content-q-svg svg")
            .eq(1)
            .css("display", "block");
    } else {
        $(this)
            .parents(".wd-product-page-faq-content")
            .find(".wd-product-page-faq-content-a")
            .slideUp();
        $(this)
            .find(".wd-product-page-faq-content-q-svg svg")
            .css("display", "none");
        $(this)
            .find(".wd-product-page-faq-content-q-svg svg")
            .eq(0)
            .css("display", "block");
    }
});

//deep filtration btn
$(".wd-product-page-hover-btn").mouseenter(function () {
    $(".wd-product-page-hover-btn-icon-semicircle-top").css(
        "animation",
        "animation-top-enter 0.5s"
    );
    $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
        "animation",
        "animation-bottom-enter 0.5s"
    );
    $(".wd-product-page-hover-btn-icon-semicircle-top").css(
        "animation-fill-mode",
        "forwards"
    );
    $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
        "animation-fill-mode",
        "forwards"
    );
});
$(".wd-product-page-hover-btn").mouseleave(function () {
    $(".wd-product-page-hover-btn-icon-semicircle-top").css(
        "animation",
        "animation-top-leave 0.5s"
    );
    $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
        "animation",
        "animation-bottom-leave 0.5s"
    );
    $(".wd-product-page-hover-btn-icon-semicircle-top").css(
        "animation-fill-mode",
        "forwards"
    );
    $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
        "animation-fill-mode",
        "forwards"
    );
});


//banner video show
$(".wd-product-1016-preheat-banner-watch").click(function () {
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-banner-video-show iframe")
        .prop("src", "https://www.youtube.com/embed/6kYBhODz7p8?si=KKF0LtAMsJ161cud");
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-banner-video-show")
        .fadeIn(200);
    $(this).parents("html").css("overflow", "hidden");
    $(this).parents(".wd-product-page-content").css("z-index", "9");
});
$(".wd-product-page-banner-video-show-btn").click(function () {
    $(this).parents(".wd-product-page-banner-video-show").fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-banner-video-show iframe")
        .prop("src", "");
    $(this).parents("html").css("overflow", "auto");
    $(this).parents(".wd-product-page-content").css("z-index", "1");
});
$(".wd-product-page-banner-video-show").click(function () {
    $(this).fadeOut(200);
    $(this)
        .parents(".wd-product-page-content")
        .find(".wd-product-page-banner-video-show iframe")
        .prop("src", "");
    $(this).parents("html").css("overflow", "auto");
    $(this).parents(".wd-product-page-content").css("z-index", "1");
});


//change font color
$('.wd-product-page-wrong-scene-text-item').mouseenter(function () {
    var index = $(this).index();
    $(this).siblings().removeClass('wd-product-page-wrong-scene-text-item-active');
    $(this).addClass('wd-product-page-wrong-scene-text-item-active');
    $(this).parents('.wd-product-page-wrong-scene').find('.wd-product-page-wrong-scene-img').find('img').css('display', 'none')
    $(this).parents('.wd-product-page-wrong-scene').find('.wd-product-page-wrong-scene-img').find('img').eq(index).css('display', 'block')
})


//change video img
$('.wd-product-page-pure-item').click(function () {
    var index = $(this).index();
    $(this).siblings().removeClass('wd-product-page-pure-item-active');
    $(this).addClass('wd-product-page-pure-item-active');
    $(this).parents('.wd-product-page-pure').find('.wd-product-page-pure-img').find('img').css('display', 'none');
    $(this).parents('.wd-product-page-pure').find('.wd-product-page-pure-img').find('img').eq(index).css('display', 'block');

})


var swiper = new Swiper(".wd-product-page-beyond-img-mySwiper", {
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    on: {
        slideChange: function () {
            if (this.activeIndex == 0) {
                $('.wd-product-page-beyond-item').removeClass("wd-product-page-beyond-item-active")
                $('.wd-product-page-beyond-item').eq(0).addClass("wd-product-page-beyond-item-active")
            } else if (this.activeIndex == 1) {
                $('.wd-product-page-beyond-item').removeClass("wd-product-page-beyond-item-active")
                $('.wd-product-page-beyond-item').eq(1).addClass("wd-product-page-beyond-item-active")
            } else if (this.activeIndex == 2) {
                $('.wd-product-page-beyond-item').removeClass("wd-product-page-beyond-item-active")
                $('.wd-product-page-beyond-item').eq(2).addClass("wd-product-page-beyond-item-active")
            } else if (this.activeIndex == 3) {
                $('.wd-product-page-beyond-item').removeClass("wd-product-page-beyond-item-active")
                $('.wd-product-page-beyond-item').eq(3).addClass("wd-product-page-beyond-item-active")
            } else {
                $('.wd-product-page-beyond-item').removeClass("wd-product-page-beyond-item-active")
                $('.wd-product-page-beyond-item').eq(0).addClass("wd-product-page-beyond-item-active")
            }
        }
    }
});

$('.wd-product-page-beyond-item').click(function () {
    var index = $(this).index();
    $(this).siblings().removeClass('wd-product-page-beyond-item-active');
    $(this).addClass('wd-product-page-beyond-item-active');
    swiper.slideTo(index)

})

var swiper1 = new Swiper(".blocks-video-items-video", {
    autoHeight: true,
    slidesPerView: "auto",
    slidecomparesrView: "auto",
    breakpoints: {
        1439: {
            centeredSlides: false,
            spaceBetween: 44,
        },
        768: {
            centeredSlides: false,
            spaceBetween: 16,
        },
        0: {
            centeredSlides: true,
            spaceBetween: 12,
        },
    },
    pagination: {
        el: ".swiper-pagination",
    },
    navigation: {
        nextEl: ".blocks-video-title-btn-next",
        prevEl: ".blocks-video-title-btn-prev",
    },
});

var swiper2 = new Swiper(".wd-v2-index-media-swiper", {
    slidecomparesrView: 'auto',
    slidesPerView: "auto",
    spaceBetween: 0,
    MouseEvent: true,
    // navigation: {
    //     nextEl: ".wd-v2-index-media-swiper-next",
    //     prevEl: ".wd-v2-index-media-swiper-prev",
    // },
});

$('.wd-v2-index-media-all .wd-v2-index-media-swiper .swiper-wrapper .wd-v2-index-media-swiper-slide').hover(function () {
    $(this).addClass('wd-v2-index-media-active').siblings('.wd-v2-index-media-swiper-slide').removeClass('wd-v2-index-media-active');
    var i = $(this).index();
    $(this).parents().siblings('.wd-v2-index-media-content').find('div').eq(i).show().siblings('div').hide();
});


var swiper_reviews = new Swiper(".wd-product-page-reviews-swiper", {
    autoplay: true,
    loop: true,
    effect: "fade",
    navigation: {
        nextEl: ".wd-product-page-reviews-swiper-button-next",
        prevEl: ".wd-product-page-reviews-swiper-button-prev",
    },
});

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Observer);
ScrollTrigger.config({ ignoreMobileResize: true });

window.addEventListener('DOMContentLoaded', function () {
    // Are you gsap

    const triggerElement = document.querySelector('.wd-product-page-text-are-you');
    let triggerStartHeight = triggerElement.offsetHeight;
    const triggerElement1 = document.querySelector('.wd-product-page-text-are-you-all');
    let triggerarewidth = triggerElement1.offsetWidth;
    let windowwidth = this.window.innerWidth;
    let windowheight = this.window.innerHeight;

    if (windowwidth > 1024) {
        gsap.timeline({
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you",
                start: "top top",
                end: "+=200%",
                pin: true, 
                // scrub: true, 

            }
        });
        gsap.to(".wd-product-page-text-are-you-all", {
            x: `-${triggerarewidth - windowwidth}`,
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-content",
                start: `top+=${triggerStartHeight * 0.2} top`,
                end: "+=200%",
                scrub: 1,
            },
        });
        gsap.to(".wd-product-page-text-are-you-content", {
            y: 0,
            opacity: 1,
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you",
                start: "top top",
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item1", {
            y: 0,
            opacity: 1,
            duration: 1,
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.2} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item2", {
            y: 0,
            opacity: 1,
            duration: 1,
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.3} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item3", {
            y: 0,
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.4} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item4", {
            y: 0,
            rotate: 0,
            opacity: 1,
            duration: 1,
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.5} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item5", {
            y: 0,
            opacity: 1,
            duration: 1,
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.6} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item6", {
            opacity: 1,
            duration: 1,
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.7} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item6 .span1", {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.8} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item6 .span2", {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.8} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item6 .span3", {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.8} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item6 .span4", {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.8} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item6 .span5", {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.8} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item6 .span6", {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.8} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item6 .span7", {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.8} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item6 .span8", {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.8} top`,
                end: "bottom bottom",
            },
        });
        gsap.to(".wd-product-page-text-are-you-item7", {
            y: 0,
            opacity: 1,
            duration: 1,
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you-all",
                start: `top+=${triggerStartHeight * 0.9} top`,
                end: "bottom bottom",
            },
        });
    } else {
        gsap.timeline({
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you",
                start: "top top",
                end: "+=100%",
                pin: true,
            }
        });
        gsap.to(".wd-product-page-text-are-you-content", {
            y: 0,
            opacity: 1,
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you",
                start: "top top",
                end: "bottom bottom",
            },
        }, 0);
        gsap.to(".wd-product-page-text-are-you-all-pad-title", {
            scale: 1,
            opacity: 1,
            duration: 2,
            ease: "elastic.out(1,0.5)",
            scrollTrigger: {
                trigger: ".wd-product-page-text-are-you",
                start: "top top",
                end: "bottom bottom",
            },
        }, 1);

    }



    // selling points gsap
    const tl_selling = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-selling-points",
            start: "top 30%",
        }
    })
    tl_selling.to(".wd-product-page-selling-points-all", { y: 0, duration: 0.5, opacity: 1 });


    // wrong scene
    const tl_wrong = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-wrong-scene",
            start: "top 10%",
            end: "bottom bottom",

        },
    })
    tl_wrong
        .to(".wd-product-page-wrong-scene-content", { y: 0, duration: 1, opacity: 1, ease: "power1.out" }, 0)
        .to(".wd-product-page-wrong-scene-text", { y: 0, duration: 1.5, ease: "power1.out", }, 0)


    // flux video
    const tl_flux = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-flux-video",
            y: () => innerHeight,
            start: "top top",
            end: "+=200%",
            scrub: 1,
            pin: true,
        },
    })
    tl_flux
        .to(".wd-product-page-flux-video-text", { y: 0, duration: 0.5, opacity: 1 }, 0)
        .to(".wd-product-page-flux-video-des", { y: 0, duration: 0.5, opacity: 1 }, 0.5)
        .to(".wd-product-page-flux-video-video video", { y: 0, duration: 0.5, opacity: 1 }, 1)

        .to(".wd-product-page-flux-video-text", { y: 0, duration: 0.5, opacity: 1 }, 1.5)
        .to(".wd-product-page-flux-video-des", { y: 0, duration: 0.5, opacity: 1 }, 1.5)
        .to(".wd-product-page-flux-video-video video", { y: 0, duration: 0.5, opacity: 1 }, 1.5)

        .to(".wd-product-page-flux-video-text", { y: -300, duration: 1, opacity: 0, height: 0 }, 2)
        .to(".wd-product-page-flux-video-des", { y: -300, duration: 1, opacity: 0, height: 0 }, 2)
        .to(".wd-product-page-flux-video-video video", { y: 0, duration: 1, opacity: 1, width: "100vw", height: "100vh", borderRadius: "0", padding: 0 }, 2)

        .to(".wd-product-page-flux-video-video video", { y: 0, duration: 1, opacity: 1, width: "100vw", height: "100vh", }, 2.5)


    // pure 
    const tl_overview = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-pure",
            y: () => innerHeight,
            start: "top 10%",
            end: "bottom bottom",
        },
    })
    tl_overview
        .to(".wd-product-page-pure-text", { y: 0, duration: 1.2, opacity: 1 }, 0)
        .to(".wd-product-page-pure-items", { y: 0, duration: 1.2, opacity: 1 }, 0)
        .to(".wd-product-page-pure-img", { y: 0, duration: 1, opacity: 1 }, 0)

    //level

    const canvas = document.getElementById("wd-product-page-next-level-canvas");
    const context = canvas.getContext("2d");

    // canvas.width = 940;
    canvas.width = 1920;
    canvas.height = 960;


    const frameCount = 200;
    const currentFrame = (index) =>
        `https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-1016-filter2024-img${(
            index + 1
        )
            .toString()
            .padStart(3, "0")}.png`;

    const images = [];
    const canvas_obj = {
        frame: 0,
    };

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
    }

    images[0].onload = render;

    function render() {
        try {
            const img = images[canvas_obj.frame]
            if (!img || !img.complete || img.naturalWidth === 0) return;
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(img, 0, 0, 1920, 960, 0, 0, canvas.width, canvas.height);
        } catch (err) {
            console.error(err);
        }
    }

    const tl_level = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-next-level",
            start: "top top",
            end: "+=100%",
            scrub: 1,
            pin: true,
        },
    })
    tl_level
        .to(".wd-product-page-next-level-title", { y: 0, duration: 0.5, opacity: 1 }, 0)
        .to(".wd-product-page-next-level-des", { y: 0, duration: 0.5, opacity: 1 }, 0)
        .to(".wd-product-page-next-level-bottom-title", { y: 0, duration: 0.5, opacity: 1 }, 0)

        .to(".wd-product-page-next-level-bottom-title", { y: 0, duration: 0, opacity: 0 }, 1.5)
        .to(".wd-product-page-next-level-bottom-text-item-1", { y: 0, duration: 1, opacity: 1 }, 1.5)
        .to(canvas_obj, {
            frame: 60,
            onUpdate: render,
            duration: 2,
            snap: "frame",
            ease: "none",
        }, 0.5)

        .to(".wd-product-page-next-level-bottom-text-item-1", { y: 0, duration: 0, opacity: 0 }, 2.5)
        .to(".wd-product-page-next-level-bottom-text-item-2", { y: 0, duration: 1, opacity: 1 }, 2.5)
        .to(canvas_obj, {
            frame: 120,
            onUpdate: render,
            duration: 2,
            snap: "frame",
            ease: "none",
        }, 2.5)

        .to(".wd-product-page-next-level-bottom-text-item-2", { y: 0, duration: 0, opacity: 0 }, 4.5)
        .to(".wd-product-page-next-level-bottom-text-item-3", { y: 0, duration: 1, opacity: 1 }, 4.5)
        .to(canvas_obj, {
            frame: 200,
            onUpdate: render,
            duration: 2,
            snap: "frame",
            ease: "none",
        }, 4.5)

    // beyond
    if (windowwidth > 1024 || windowwidth < 768) {
        const tl_beyond = gsap.timeline({
            scrollTrigger: {
                trigger: ".wd-product-page-beyond",
                start: "top 20%",
                end: "bottom bottom",
            },
        })
        tl_beyond
            .to(".wd-product-page-beyond-content", { y: 0, duration: 0.5, opacity: 1 }, 0)
            .to(".wd-product-page-beyond-img", { y: 0, duration: 1, opacity: 1 }, 0.5)
            .to(".wd-product-page-beyond-text", { y: 0, duration: 1.3, opacity: 1 }, 0.5)
            .to(".wd-product-page-beyond-choose", { y: 0, duration: 1.3, opacity: 1 }, 0.5)

    } else {
        const tl_beyond = gsap.timeline({
            scrollTrigger: {
                trigger: ".wd-product-page-beyond",
                start: "top top",
                end: "bottom bottom",
            },
        })
        tl_beyond
            .to(".wd-product-page-beyond-content", { y: 0, duration: 0.5, opacity: 1 }, 0)
            .to(".wd-product-page-beyond-img", { x: 0, duration: 1, opacity: 1 }, 0.5)
            .to(".wd-product-page-beyond-text", { y: 0, duration: 1.3, opacity: 1 }, 0.5)
    }

    // Authoritative
    const tl_authoritative = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-authoritative",
            start: "top 20%",
            end: "bottom bottom",
        },
    })
    tl_authoritative
        .to(".wd-product-page-authoritative-content", { y: 0, duration: 0.5, opacity: 1 }, 0)

    // smart quantitative
    const tl_smart = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-smart",
            start: "top 20%",
            end: "bottom bottom",
        },
    })
    tl_smart
        .to(".wd-product-page-smart-content", { y: 0, duration: 0.5, opacity: 1 }, 0)

    // bibcock

    const canvas2 = document.getElementById("wd-product-page-bibcock-item-canvas");
    const context2 = canvas2.getContext("2d");

    canvas2.width = 1500;
    canvas2.height = 1500;


    const frameCount2 = 224;
    const currentFrame2 = (index) =>
        `https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-1016-page-2024-7-faucet-img-${(
            index
        )
            .toString()
            .padStart(3, "0")}.png`;

    const images2 = [];
    const canvas_obj2 = {
        frame: 0,
    };

    for (let i = 0; i < frameCount2; i++) {
        const img = new Image();
        img.src = currentFrame2(i);
        images2.push(img);
    }

    images2[0].onload = render2;

    function render2() {
        try {
            const img2 = images2[canvas_obj2.frame]
            if (!img2 || !img2.complete || img2.naturalWidth === 0) return;
            context2.clearRect(0, 0, canvas2.width, canvas2.height);
            context2.drawImage(img2, 0, 0, 1500, 1500, 0, 0, canvas2.width, canvas2.height);
        } catch (err) {
            console.error(err);
        }
    }
    const tl_bibcock = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-bibcock",
            start: "top top",
            end: "+=300%",
            scrub: 1,
            pin: true,
        },
    })
    tl_bibcock
        .to(".wd-product-page-bibcock-content", { duration: 0.5, opacity: 1 }, 0)

        .to(".wd-product-page-bibcock-item-canvas", { duration: 1, opacity: 1 }, 0.5)
        .to(".wd-product-page-bibcock-item-text1", { duration: 1, opacity: 1 }, 0.5)
        .to(canvas_obj2, {
            frame: 70,
            onUpdate: render2,
            duration: 1,
            snap: "frame",
            ease: "none",
        }, 0.5)

        .to(".wd-product-page-bibcock-item-text1", { duration: 1, opacity: 1 }, 1.3)
        .to(".wd-product-page-bibcock-item-text1", { duration: 1, opacity: 0 }, 1.4)
        .to(".wd-product-page-bibcock-item-text2", { duration: 1, opacity: 0 }, 1.4)
        .to(".wd-product-page-bibcock-item-text2", { duration: 1, opacity: 1 }, 1.5)
        .to(canvas_obj2, {
            frame: 140,
            onUpdate: render2,
            duration: 1,
            snap: "frame",
            ease: "none",
        }, 1.5)

        .to(".wd-product-page-bibcock-item-text2", { duration: 1, opacity: 1 }, 2.3)
        .to(".wd-product-page-bibcock-item-text2", { duration: 1, opacity: 0 }, 2.4)
        .to(".wd-product-page-bibcock-item-text3", { duration: 1, opacity: 0 }, 2.4)
        .to(".wd-product-page-bibcock-item-text3", { duration: 1, opacity: 1 }, 2.5)
        .to(canvas_obj2, {
            frame: 224,
            onUpdate: render2,
            duration: 1,
            snap: "frame",
            ease: "none",
        }, 2.5)

    // undersink
    if (windowwidth > 1024) {
        const tl_undersink = gsap.timeline({
            scrollTrigger: {
                trigger: ".wd-product-page-undersink",
                start: "top top",
                end: "+=300%",
                scrub: 1,
                pin: true,
            },
        })
        var tl_undersink_element = document.querySelector('.wd-product-page-undersink-item1');
        var tl_undersink_style = window.getComputedStyle(tl_undersink_element);
        var tl_undersink_columnGap = tl_undersink_style.getPropertyValue('column-gap');
        tl_undersink
            .to('.wd-product-page-undersink-img img', { y: 0, duration: 0.5, opacity: 1 }, 0)
            .to('.wd-product-page-undersink-text-title', { top: "20%", duration: 1, opacity: 1 }, 0.5)

            .to('.wd-product-page-undersink-text-title', { top: "20%", duration: 1, opacity: 0 }, 1.5)
            .to('.wd-product-page-undersink-img img', { duration: 1, opacity: 0 }, 1.5)
            .to('.wd-product-page-undersink-product img', { duration: 1, opacity: 1 }, 1.5)



            .to('.wd-product-page-undersink-text-title', { top: "20%", duration: 1, opacity: 0 }, 2.5)
            .to('.wd-product-page-undersink-product img', { duration: 1, opacity: 1 }, 2.5)

            .to('.wd-product-page-undersink-product', {
                width: `${document.querySelector('.wd-product-page-undersink-item-img1').offsetWidth}`, height: `${document.querySelector('.wd-product-page-undersink-item-img1').offsetWidth}`,
                bottom: `${windowheight * 0.5 - document.querySelector('.wd-product-page-undersink-item-img1').offsetWidth * 0.5}`,
                right: `${windowwidth * 0.5 - document.querySelector('.wd-product-page-undersink-item-img1').offsetWidth - tl_undersink_columnGap.split('px')[0] * 0.5}`,
                duration: 1, opacity: 1
            }, 2.5)

            .to('.wd-product-page-undersink-product img', {
                width: "100%",
            }, 2.5)

            .to('.wd-product-page-undersink-product img', { duration: 1, opacity: 0 }, 3.5)
            .to('.wd-product-page-undersink-item1', { duration: 1, opacity: 1 }, 3.5)

            .to('.wd-product-page-undersink-item1', { duration: 1, opacity: 0 }, 4.5)
            .to('.wd-product-page-undersink-item2', { duration: 1, opacity: 1, y: 0 }, 5.5)

            .to('.wd-product-page-undersink-item2', { duration: 1, opacity: 1, y: 0 }, 6.5)
            .to('.wd-product-page-undersink-item2', { duration: 1, opacity: 0, y: 0 }, 6.75)

            .to('.wd-product-page-undersink-item3', { duration: 1, opacity: 0, y: 0 }, 6.75)
            .to('.wd-product-page-undersink-item3', { duration: 1, opacity: 1, y: 0 }, 7.75)
    } else if (windowwidth > 767) {
        const tl_undersink = gsap.timeline({
            scrollTrigger: {
                trigger: ".wd-product-page-undersink",
                start: "top top",
                end: "+=300%",
                scrub: 1,
                pin: true,
            },
        })
        var tl_undersink_element = document.querySelector('.wd-product-page-undersink-item1');
        var tl_undersink_style = window.getComputedStyle(tl_undersink_element);
        var tl_undersink_columnGap = tl_undersink_style.getPropertyValue('column-gap');
        tl_undersink
            .to('.wd-product-page-undersink-img img', { y: 0, duration: 0.5, opacity: 1 }, 0)
            .to('.wd-product-page-undersink-text-title', { top: "20%", duration: 1, opacity: 1 }, 0.5)

            .to('.wd-product-page-undersink-img img', { y: 0, duration: 1, opacity: 0 }, 1.5)
            .to('.wd-product-page-undersink-text-title', { top: "20%", duration: 1, opacity: 0 }, 1.5)
            .to('.wd-product-page-undersink-product img', { duration: 1, opacity: 1 }, 1.5)

            .to('.wd-product-page-undersink-text-title', { top: "20%", duration: 1, opacity: 0 }, 2.5)
            .to('.wd-product-page-undersink-product img', { duration: 1, opacity: 1 }, 2.5)

            .to('.wd-product-page-undersink-product', {
                width: `${document.querySelector('.wd-product-page-undersink-item-img1').offsetWidth}`, height: `${document.querySelector('.wd-product-page-undersink-item-img1').offsetWidth}`,
                bottom: 80,
                right: `calc(50% - 300px)`,
                duration: 1, opacity: 1
            }, 2.5)

            .to('.wd-product-page-undersink-product img', {
                width: "100%",
            }, 2.5)

            .to('.wd-product-page-undersink-product img', { duration: 1, opacity: 0 }, 3.5)
            .to('.wd-product-page-undersink-item1', { duration: 1, opacity: 1 }, 3.5)

            .to('.wd-product-page-undersink-item1', { duration: 1, opacity: 0 }, 4.5)
            .to('.wd-product-page-undersink-item2', { duration: 1, opacity: 1, y: 0 }, 5.5)

            .to('.wd-product-page-undersink-item2', { duration: 1, opacity: 1, y: 0 }, 6.5)
            .to('.wd-product-page-undersink-item2', { duration: 1, opacity: 0, y: 0 }, 6.75)

            .to('.wd-product-page-undersink-item3', { duration: 1, opacity: 0, y: 0 }, 6.75)
            .to('.wd-product-page-undersink-item3', { duration: 1, opacity: 1, y: 0 }, 7.75)
    } else {
        const tl_undersink = gsap.timeline({
            scrollTrigger: {
                trigger: ".wd-product-page-undersink",
                start: "top top",
                end: "+=300%",
                scrub: 1,
                pin: true,
            },
        })
        var tl_undersink_element = document.querySelector('.wd-product-page-undersink-item1');
        var tl_undersink_style = window.getComputedStyle(tl_undersink_element);
        var tl_undersink_columnGap = tl_undersink_style.getPropertyValue('column-gap');
        tl_undersink
            .to('.wd-product-page-undersink-img img', { y: 0, duration: 0.5, opacity: 1 }, 0)
            .to('.wd-product-page-undersink-text-title', { top: "20%", duration: 1, opacity: 1 }, 0.5)

            .to('.wd-product-page-undersink-img img', { y: 0, duration: 1, opacity: 0 }, 1.5)
            .to('.wd-product-page-undersink-text-title', { top: "20%", duration: 1, opacity: 0 }, 1.5)
            .to('.wd-product-page-undersink-product img', { duration: 1, opacity: 1 }, 1.5)

            .to('.wd-product-page-undersink-text-title', { top: "20%", duration: 1, opacity: 0 }, 2.5)
            .to('.wd-product-page-undersink-product img', { duration: 1, opacity: 1 }, 2.5)

            .to('.wd-product-page-undersink-product', {
                width: `${document.querySelector('.wd-product-page-undersink-item-img1').offsetWidth}`, height: `${document.querySelector('.wd-product-page-undersink-item-img1').offsetWidth}`,
                bottom: 100,
                right: 16,
                duration: 1, opacity: 1
            }, 2.5)

            .to('.wd-product-page-undersink-product img', {
                width: "100%",
            }, 2.5)

            .to('.wd-product-page-undersink-product img', { duration: 1, opacity: 0 }, 3.5)
            .to('.wd-product-page-undersink-item1', { duration: 1, opacity: 1 }, 3.5)

            .to('.wd-product-page-undersink-item1', { duration: 1, opacity: 0 }, 4.5)
            .to('.wd-product-page-undersink-item2', { duration: 1, opacity: 1, y: 0 }, 5.5)

            .to('.wd-product-page-undersink-item2', { duration: 1, opacity: 1, y: 0 }, 6.5)
            .to('.wd-product-page-undersink-item2', { duration: 1, opacity: 0, y: 0 }, 6.75)

            .to('.wd-product-page-undersink-item3', { duration: 1, opacity: 0, y: 0 }, 6.75)
            .to('.wd-product-page-undersink-item3', { duration: 1, opacity: 1, y: 0 }, 7.75)
    }


    // blocks items
    const tl_item1 = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-blocks-item-content1",
            start: "top 20%",
            end: "bottom bottom",
        },
    })
    tl_item1
        .to('.wd-product-page-blocks-item1', { y: 0, duration: 0.5, opacity: 1 }, 0)
    const tl_item2 = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-blocks-item-content2",
            start: "top 20%",
            end: "bottom bottom",
        },
    })
    tl_item2
        .to('.wd-product-page-blocks-item2', { y: 0, duration: 0.5, opacity: 1 }, 0)
    const tl_item3 = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-blocks-item-content3",
            start: "top 20%",
            end: "bottom bottom",
        },
    })
    tl_item3
        .to('.wd-product-page-blocks-item3', { y: 0, duration: 0.5, opacity: 1 }, 0)


    // blocks 31 video
    const tl_block_video = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-product-page-blocks-31-video",
            start: "top 20%",
            end: "bottom bottom",
        },
    })
    tl_block_video
        .to('.wd-product-page-blocks-31-video-all', { y: 0, duration: 0.5, opacity: 1 }, 0)
})



$(window).scroll(function () {
    let scoll_h = $(window).scrollTop();
    let dom_h1 = $('.wd-product-page-selling-points').offset().top;
    let dom_h2 = $('.wd-product-page-flux-video').offset().top;
    let dom_h3 = $('.wd-product-page-next-level').offset().top;
    let dom_h4 = $('.wd-product-page-authoritative').offset().top;
    let dom_h5 = $('.wd-product-page-bibcock').offset().top;
    let dom_h6 = $('.wd-product-page-blocks-31-video').offset().top;
    let dom_h7 = $('.wd-product-page-in-box').offset().top;
    $('.wd-product-left-menu-items').find('.wd-product-left-menu-item').removeClass('wd-product-left-menu-item-active')
    if (scoll_h >= dom_h7) {

        $('.wd-product-left-menu-items').find('.wd-product-left-menu-item').eq(6).addClass('wd-product-left-menu-item-active')
    } else if (scoll_h >= dom_h6) {
        $('.wd-product-left-menu-items').find('.wd-product-left-menu-item').eq(5).addClass('wd-product-left-menu-item-active')
    } else if (scoll_h >= dom_h5) {
        $('.wd-product-left-menu-items').find('.wd-product-left-menu-item').eq(4).addClass('wd-product-left-menu-item-active')
    } else if (scoll_h >= dom_h4) {
        $('.wd-product-left-menu-items').find('.wd-product-left-menu-item').eq(3).addClass('wd-product-left-menu-item-active')
    } else if (scoll_h >= dom_h3) {
        $('.wd-product-left-menu-items').find('.wd-product-left-menu-item').eq(2).addClass('wd-product-left-menu-item-active')
    } else if (scoll_h >= dom_h2) {
        $('.wd-product-left-menu-items').find('.wd-product-left-menu-item').eq(1).addClass('wd-product-left-menu-item-active')
    } else if (scoll_h >= dom_h1) {
        $('.wd-product-left-menu-items').find('.wd-product-left-menu-item').eq(0).addClass('wd-product-left-menu-item-active')
        $('.wd-product-left-menu').css({ 'transform': 'translateY(-50%)', "opacity": '1', "z-index": "3" })
    } else {
        $('.wd-product-left-menu').css({ 'transform': 'translateY(calc(-50% + 300px))', "opacity": '0', "z-index": "-1" })
    }
})
$('.wd-product-left-menu-item').click(function () {
    let dom_h1 = $('.wd-product-page-selling-points').offset().top;
    let dom_h2 = $('.wd-product-page-flux-video').offset().top;
    let dom_h3 = $('.wd-product-page-next-level').offset().top;
    let dom_h4 = $('.wd-product-page-authoritative').offset().top;
    let dom_h5 = $('.wd-product-page-smart').offset().top;
    let dom_h6 = $('.wd-product-page-blocks-31-video').offset().top;
    let dom_h7 = $('.wd-product-page-in-box').offset().top;
    var index = $(this).index();
    $(this).siblings().removeClass('wd-product-left-menu-item-active');
    $(this).addClass('wd-product-left-menu-item-active');
    if (index == 0) {
        $('html, body').animate({
            scrollTop: dom_h1
        }, 500);
    } else if (index == 1) {
        $('html, body').animate({
            scrollTop: dom_h2 + 200
        }, 500);
    } else if (index == 2) {
        $('html, body').animate({
            scrollTop: dom_h3
        }, 500);
    } else if (index == 3) {
        $('html, body').animate({
            scrollTop: dom_h4
        }, 500);
    } else if (index == 4) {
        $('html, body').animate({
            scrollTop: dom_h5
        }, 500);
    } else if (index == 5) {
        $('html, body').animate({
            scrollTop: dom_h6
        }, 500);
    } else {
        $('html, body').animate({
            scrollTop: dom_h7
        }, 500);
    }
})
$('.wd-product-page-selling-point-item').click(function () {
    let dom_h1 = $('.wd-product-page-flux-video').offset().top;
    let dom_h2 = $('.wd-product-page-next-level').offset().top;
    let dom_h3 = $('.wd-product-page-beyond').offset().top;
    let dom_h4 = $('.wd-product-page-smart').offset().top;
    let dom_h5 = $('.wd-product-page-authoritative').offset().top;
    let dom_h6 = $('.wd-product-page-blocks-31-video').offset().top;
    var index = $(this).data('index');
    $(this).siblings().removeClass('wd-product-left-menu-item-active');
    $(this).addClass('wd-product-left-menu-item-active');
    if (index == 1) {
        $('html, body').animate({
            scrollTop: dom_h1 + 200
        }, 500);
    } else if (index == 2) {
        $('html, body').animate({
            scrollTop: dom_h2
        }, 500);
    } else if (index == 3) {
        $('html, body').animate({
            scrollTop: dom_h3
        }, 500);
    } else if (index == 4) {
        $('html, body').animate({
            scrollTop: dom_h4
        }, 500);
    } else if (index == 5) {
        $('html, body').animate({
            scrollTop: dom_h5
        }, 500);
    } else if (index == 6) {
        $('html, body').animate({
            scrollTop: dom_h6
        }, 500);
    }
})

$('.wd-product-page-in-box-content-choose-item').click(function () {
    var index = $(this).index();
    $(this).siblings().removeClass('wd-product-page-in-box-content-choose-item-active');
    $(this).addClass('wd-product-page-in-box-content-choose-item-active');
    $(this).parents('.wd-product-page-in-box').find('.wd-product-page-in-box-content-item').css('display', 'none')
    $(this).parents('.wd-product-page-in-box').find('.wd-product-page-in-box-content-item').eq(index).css('display', 'flex')
    $(this).parents('.wd-product-page-in-box').find('.wd-product-page-in-box-content-swiper').css('display', 'none')
    $(this).parents('.wd-product-page-in-box').find('.wd-product-page-in-box-content-swiper').eq(index).css('display', 'flex')
})
var swiper_bottom_inbox_swiper1 = new Swiper(".wd-product-page-in-box-content-swiper1", {
    pagination: {
        el: ".wd-product-page-in-box-content-swiper1-swiper-pagination",
    },
});
var swiper_bottom_inbox_swiper2 = new Swiper(".wd-product-page-in-box-content-swiper2", {
    pagination: {
        el: ".wd-product-page-in-box-content-swiper2-swiper-pagination",
    },
});
var swiper_bottom_inbox_swiper3 = new Swiper(".wd-product-page-in-box-content-swiper3", {
    pagination: {
        el: ".wd-product-page-in-box-content-swiper3-swiper-pagination",
    },
});

$(document).on('click', '.wd-product-compare-box-add-to-cart', function () {
    var ID = $(this).data('id');
    if (!ID) return;
    Shopify.addToCart(ID, 1)
    
})

$(document).on('click', '.wd-product-vis-banner-bottom-svg', function () {
  var banner_height = $(this).parents('.wd-product-1016-preheat-banner').height();
  $('html, body').animate({
    scrollTop: banner_height
  }, 500);
})